module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig = model.config || {}\nconst appearanceType = fieldConfig.appearanceType || 'tripDriverVessel'\nconst attributes = (rowResourceData || {}).attributes || {}\nconst conflicts = Object.values(attributes.conflicts || [])\nlet nrOfConflicts = 0\nlet nrOfConflictTrips = 0\nlet tripIDs = []\nlet conflictTripIDs = ''\nif(appearanceType === 'trip') {\ntripIDs = Object.keys(attributes.conflictTripIDs || {})\nnrOfConflicts = attributes.nrOfTripDriverVesselConflicts\nnrOfConflictTrips = tripIDs.length\nconflictTripIDs = tripIDs.join(', ')\n} else if(conflicts.length) {\nconst foundTripIDs = {}\nlet tripID\nfor(const conflict of conflicts) {\nif((tripID = ((conflict || {}).data || {}).tripID)){\nfoundTripIDs[tripID] = true\n}\n}\nconst tripIDs = Object.keys(foundTripIDs)\nconflictTripIDs = tripIDs.join(', ')\nnrOfConflictTrips = tripIDs.length\n}\nconst finalStatus = {\nicon: 'fi fi-check',\nstatusClass: 'ok',\nmessageKey: 'table.fields.tripDriverVesselStatus.ok',\n}\nif(nrOfConflictTrips > 0) {\nfinalStatus.icon = 'fi fi-severity-warning'\nfinalStatus.statusClass = 'warning'\nfinalStatus.messageKey = `table.fields.tripDriverVesselStatus.warning.${appearanceType}.${nrOfConflictTrips > 1 ? 'multi' : 'single'}`\n}\n// define style\nconst additionalClasses = []\nif(finalStatus.statusClass){\nadditionalClasses.push(`status_${finalStatus.statusClass}`)\n}\nconst additionalAttributes = []\nif(additionalClasses.length > 0){\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\n}\nif(finalStatus.messageKey){\nfinalStatus.message = storage.__(finalStatus.messageKey, {\ncount: nrOfConflicts,\nnrOfConflictTrips,\nconflictTripIDs\n})\n}\nif(finalStatus.message){\nadditionalAttributes.push(`title=\"${finalStatus.message}\"`)\n}\n%><div <%- additionalAttributes.join(' ')%>><%\nif(finalStatus.icon){\n%><i class=\"<%= finalStatus.icon %>\"></i><%\n}\n%></div>"
  , __filename = "components/templates/core/table/fields/tripDriverVesselStatus.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig = model.config || {}
const appearanceType = fieldConfig.appearanceType || 'tripDriverVessel'
const attributes = (rowResourceData || {}).attributes || {}
const conflicts = Object.values(attributes.conflicts || [])
let nrOfConflicts = 0
let nrOfConflictTrips = 0
let tripIDs = []
let conflictTripIDs = ''
if(appearanceType === 'trip') {
tripIDs = Object.keys(attributes.conflictTripIDs || {})
nrOfConflicts = attributes.nrOfTripDriverVesselConflicts
nrOfConflictTrips = tripIDs.length
conflictTripIDs = tripIDs.join(', ')
} else if(conflicts.length) {
const foundTripIDs = {}
let tripID
for(const conflict of conflicts) {
if((tripID = ((conflict || {}).data || {}).tripID)){
foundTripIDs[tripID] = true
}
}
const tripIDs = Object.keys(foundTripIDs)
conflictTripIDs = tripIDs.join(', ')
nrOfConflictTrips = tripIDs.length
}
const finalStatus = {
icon: 'fi fi-check',
statusClass: 'ok',
messageKey: 'table.fields.tripDriverVesselStatus.ok',
}
if(nrOfConflictTrips > 0) {
finalStatus.icon = 'fi fi-severity-warning'
finalStatus.statusClass = 'warning'
finalStatus.messageKey = `table.fields.tripDriverVesselStatus.warning.${appearanceType}.${nrOfConflictTrips > 1 ? 'multi' : 'single'}`
}
// define style
const additionalClasses = []
if(finalStatus.statusClass){
additionalClasses.push(`status_${finalStatus.statusClass}`)
}
const additionalAttributes = []
if(additionalClasses.length > 0){
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)
}
if(finalStatus.messageKey){
finalStatus.message = storage.__(finalStatus.messageKey, {
count: nrOfConflicts,
nrOfConflictTrips,
conflictTripIDs
})
}
if(finalStatus.message){
additionalAttributes.push(`title="${finalStatus.message}"`)
}

    ; __line = 56
    ; __append("<div ")
    ; __append( additionalAttributes.join(' '))
    ; __append(">")
    ; 
if(finalStatus.icon){

    ; __line = 58
    ; __append("<i class=\"")
    ; __append(escapeFn( finalStatus.icon ))
    ; __append("\"></i>")
    ; 
}

    ; __line = 60
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/table/fields/tripDriverVesselStatus.ejs

}